export default __webpack_public_path__ + "static/media/cover1.b653197e.png";